 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~955b2d54":"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~955b2d54","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~a2405b76":"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~a2405b76","receipts~sellers-visits~stocks":"receipts~sellers-visits~stocks","stocks":"stocks","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~ca6bff73":"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~ca6bff73","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~262e0591":"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~262e0591","articles":"articles","campaigns":"campaigns","crops":"crops","dashboard":"dashboard","delivery_notes":"delivery_notes","distributors":"distributors","distributors-orders":"distributors-orders","distributors-projections":"distributors-projections","documents":"documents","dollar-quotations":"dollar-quotations","fields":"fields","orders":"orders","plots":"plots","producers":"producers","producers-documents":"producers-documents","producers-projections":"producers-projections","projections":"projections","quotations":"quotations","roles":"roles","sellers":"sellers","sellers-orders":"sellers-orders","users":"users","varieties":"varieties","visits":"visits","receipts":"receipts","producers-contacts":"producers-contacts","sellers-visits":"sellers-visits","auth-pages":"auth-pages"}[chunkId]||chunkId) + "." + {"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~955b2d54":"e7ddea9a","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~a2405b76":"2fb0bcbc","receipts~sellers-visits~stocks":"62d9a309","stocks":"5d3d9568","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~ca6bff73":"29ed7c70","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~262e0591":"38bc0715","articles":"b351c212","campaigns":"6da30017","crops":"8015e27e","dashboard":"b5f11354","delivery_notes":"b90b63de","distributors":"2f4bcec0","distributors-orders":"130710eb","distributors-projections":"db3cad37","documents":"9fb99e3f","dollar-quotations":"c8495ccb","fields":"526a85ad","orders":"2cb814dd","plots":"0ca1b73b","producers":"f84f5ee7","producers-documents":"9f54d7f4","producers-projections":"26484dff","projections":"b18791e3","quotations":"15dc2452","roles":"64b9ba19","sellers":"3de5792d","sellers-orders":"71699f3b","users":"1401a2fe","varieties":"7354e53e","visits":"71759d34","receipts":"b5fdc5dd","producers-contacts":"cc8df17d","sellers-visits":"f9727e35","auth-pages":"cc22d660","chunk-d0d22142":"76354881","chunk-8d70c9d0":"14460c3e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~955b2d54":1,"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~a2405b76":1,"receipts~sellers-visits~stocks":1,"stocks":1,"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~262e0591":1,"articles":1,"campaigns":1,"crops":1,"dashboard":1,"delivery_notes":1,"distributors":1,"distributors-orders":1,"distributors-projections":1,"documents":1,"dollar-quotations":1,"fields":1,"orders":1,"plots":1,"producers":1,"producers-projections":1,"projections":1,"quotations":1,"roles":1,"sellers":1,"sellers-orders":1,"users":1,"varieties":1,"visits":1,"receipts":1,"producers-contacts":1,"sellers-visits":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~955b2d54":"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~955b2d54","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~a2405b76":"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~a2405b76","receipts~sellers-visits~stocks":"receipts~sellers-visits~stocks","stocks":"stocks","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~ca6bff73":"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~ca6bff73","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~262e0591":"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~262e0591","articles":"articles","campaigns":"campaigns","crops":"crops","dashboard":"dashboard","delivery_notes":"delivery_notes","distributors":"distributors","distributors-orders":"distributors-orders","distributors-projections":"distributors-projections","documents":"documents","dollar-quotations":"dollar-quotations","fields":"fields","orders":"orders","plots":"plots","producers":"producers","producers-documents":"producers-documents","producers-projections":"producers-projections","projections":"projections","quotations":"quotations","roles":"roles","sellers":"sellers","sellers-orders":"sellers-orders","users":"users","varieties":"varieties","visits":"visits","receipts":"receipts","producers-contacts":"producers-contacts","sellers-visits":"sellers-visits","auth-pages":"auth-pages"}[chunkId]||chunkId) + "." + {"articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~955b2d54":"f5290e7b","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~a2405b76":"3650a818","receipts~sellers-visits~stocks":"a4531f1d","stocks":"3c438657","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~ca6bff73":"31d6cfe0","articles~campaigns~crops~dashboard~delivery_notes~distributors~distributors-orders~distributors-proj~262e0591":"dc132df4","articles":"79109d5c","campaigns":"bdee820f","crops":"020eaa86","dashboard":"b830e7d5","delivery_notes":"3bf73fde","distributors":"9bf0b42f","distributors-orders":"ca958ce3","distributors-projections":"1cb1f4b5","documents":"c99707f6","dollar-quotations":"146e71ca","fields":"2841f3ca","orders":"9f134261","plots":"c8ddccd3","producers":"fa95330f","producers-documents":"31d6cfe0","producers-projections":"56034f0d","projections":"dc34fd73","quotations":"99145812","roles":"51842bcd","sellers":"d54e5a1a","sellers-orders":"a29c7847","users":"ac10d4a2","varieties":"7a875c64","visits":"b26c93e0","receipts":"b2c9556d","producers-contacts":"2cebf762","sellers-visits":"dd8c6a6d","auth-pages":"31d6cfe0","chunk-d0d22142":"31d6cfe0","chunk-8d70c9d0":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
